// extracted by mini-css-extract-plugin
module.exports = {"root":"AutoTheoriepruefungPage_root__1iRrJ","mainImage":"AutoTheoriepruefungPage_mainImage__2-thP","mainTitle":"AutoTheoriepruefungPage_mainTitle__1aKAf"};